module.exports = __webpack_public_path__ + "img/20_135.7e4346ef.png";